/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
*/

import axios from 'axios';
import { Toast } from "vant";
import router from '@/router'; // 假设路由文件路径是 @/router，根据实际情况调整

// 创建 Axios 实例，默认使用 VUE_APP_PROJECT_API 作为基础路径
const axiosInstance = axios.create({
  timeout: 8000, // 设置请求的最大等待时间为 8 秒
  baseURL: process.env.VUE_APP_PROJECT_API // 默认使用项目接口域名
});

// 请求拦截器
axiosInstance.interceptors.request.use(config => {
  // 检查是否有自定义标记 isPublicApi
  if (config.isPublicApi) {
    config.baseURL = process.env.VUE_APP_PUBLIC_API;
  }

  // 可以添加认证信息（如 token）到请求头
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, error => {
  // 请求失败时，直接返回错误
  return Promise.reject(error);
});

// 响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    // 只处理成功的响应，避免过多判断
    return response.data;
  },
  error => {
    const { response } = error;

    if (response) {
      // 根据 HTTP 状态码分类处理错误
      const status = response.status;
      switch (status) {
        case 401:
          // 401：未授权，跳转到登录页
          handleUnauthorized();
          break;
        case 403:
          // 403：禁止访问，可能是登录过期，提示用户重新登录
          handleSessionExpired();
          break;
        case 404:
          // 404：请求资源未找到
          showToast('网络请求不存在', 1500);
          break;
        default:
          // 其他未知错误
          showToast('接口请求失败', 1500);
      }
    } else {
      // 没有响应时的错误，比如网络中断
      showToast('请求超时或网络错误', 1500);
    }

    return Promise.reject(error); // 返回错误信息
  }
);

// 提示信息函数，封装 Toast 提示
function showToast(message, duration) {
  Toast({
    message,
    duration,
    forbidClick: true,
  });
}

// 处理未授权的情况（如登录失效）
function handleUnauthorized() {
  router.replace({
    path: '/login',
    query: { redirect: router.currentRoute.fullPath }
  });
}

// 处理会话过期的情况，提示重新登录
function handleSessionExpired() {
  showToast('登录过期，请重新登录', 1000);
  setTimeout(() => {
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.fullPath }
    });
  }, 1000);
}

export default axiosInstance;